import quoteTranslations from "./quote/de-DE";

const deDE = {
  ...quoteTranslations,
  acMenuPlannedShipments: "Geplante Lieferungen",
  acMenuQuotes: "Quoten",
};

export  { deDE };
